

<script>
import store from '../store/index.js';
import {reduce} from 'lodash';
export default {
    data(){
        return {
            list: [
                {
                    title: '红旗点赞中国进行中，快来参与吧',
                    tag: 'zhibo',
                    img: '//www2.autoimg.cn/zxpt/g26/M0B/7A/8B/160x90_0_autohomecar__ChsEnF2V5l6Af1o3AAJ4qnYdHqs947.jpg',
                    desc: '赵钱孙李周吴郑王',
                    photo: require('../../assets/default_map.png'),
                    name: '张三2',
                    playCount: '3.4',
                    url: ''
                },
                {
                    title: '红旗点赞中国, 快进来，开始了，早参与早优惠',
                    tag: 'zhibo',
                    img: '//www2.autoimg.cn/zxpt/g29/M02/FE/B0/160x90_0_autohomecar__ChsEn128QguAKfzRAAJCm9Rvijc626.jpg',
                    desc: '赵钱孙李周吴郑王',
                    photo: require('../../assets/default_map.png'),
                    name: '张三2',
                    playCount: '3.4',
                    url: ''
                },
                {
                    title: '红旗点赞中国',
                    tag: 'huifang',
                    img: require('../../assets/default_map.png'),
                    desc: '赵钱孙李周吴郑王',
                    photo: require('../../assets/default_map.png'),
                    name: '张三2',
                    playCount: '3.4',
                    url: ''
                },
                {
                    title: '红旗点赞中国',
                    tag: 'huifang',
                    img: require('../../assets/default_map.png'),
                    desc: '赵钱孙李周吴郑王',
                    photo: require('../../assets/default_map.png'),
                    name: '张三2',
                    playCount: '3.4',
                    url: ''
                },
            ]
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.addMointor();
        })
    },
    components: {
    },
    methods: {
        getTit(title) {
            if(title.length > 25) {
                return title.substring(0,7) + '...';
            } else {
                return title;
            }
        },
        jump(url) {
            window.open(url);
        },
        addMointor() {
            // 曝光
            this.$clickMonitor.update(reduce(document.querySelectorAll('.j-zhibo'), (arr, el) => {
				const callback = function (params) {
					const buttonId = `zhibo-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'expose', callback});
				return arr;
            }, []));
            
            // 点击
			this.$clickMonitor.update(reduce(document.querySelectorAll('.j-zhibo-item'), (arr, el) => {
				const callback = function (params) {
					const index = params.options.el.getAttribute('data-index');
					const buttonId = `zhibo-${+index + 1}-${params.monitor.status}`;
					return {
						buttonId,
						...store.getClickMonitorParams()
					};
				};
				arr.push({el, event: 'click', callback});
				return arr;
            }, []));
            
		}
    }
}
</script>
<template>
  <div class="wrap">
      <h3 class="title">直播专区</h3>
      <div class="main j-zhibo">
        <div class="item j-zhibo-item" v-for="(item, index) in list" :key="item.title" @click="jump(item.url)" :data-index="index">
           <div class="imgWrap">
               <img :src="item.img" :alt="item.title">
               <span class="item-tag" :class="item.tag"><i class="icon"></i> {{ item.tag=='zhibo' ? '直播中': '回放'}}</span>
               <span class="item-title">{{ getTit(item.title) }}</span>
           </div>
           <div class="info">
               <p>
                    <span class="photo"><img :src="item.photo"></span>
                    <span class="name">{{ item.name }}</span>
               </p>
               <span class="count">{{ item.playCount }}完播放</span>
           </div>
        </div>
      </div>
  </div>
</template>
<style lang="stylus" scoped>
    .wrap
        margin-bottom 1rem
        .title
            margin 0.5rem auto
            position relative
            width 6.72rem
            text-indent 2.05rem
            &:before
                content ''
                position absolute
                left 0.7rem
                top .3rem
                width 1.07rem
                height 1.01rem
                background url("../../assets/title_zb_bg.svg") no-repeat
                background-size 100% 100%
            &:after
                content ''
                display inline-block
                position absolute
                left 0
                bottom 0
                width 100%
                height 0.11rem
                background url("../../assets/title_line.png") top left no-repeat
                background-size 100%
        .main
            background #ffffff
            margin 0 auto
            width 17.33rem
            height 17.6rem
            padding 1.2rem 0.53rem
            display flex
            flex-wrap wrap
            justify-content space-between
            box-sizing border-box
            border-radius 0.27rem
            .item
                width 7.84rem
                margin-bottom 0.85rem
                .imgWrap
                    position relative
                    width 7.84rem
                    height 5.85rem
                    border-radius 0.21rem
                    img 
                        width 100%
                        height 100%
                        border-radius 0.21rem
                .item-tag
                    position absolute
                    top 0
                    left 0
                    width:2.99rem;
                    height:0.91rem;
                    line-height 0.91rem
                    border-radius:0.21rem 0rem 0.21rem 0rem;
                    color #ffffff
                    font-size 0.59rem
                    font-style normal
                    text-indent .2rem
                    .icon
                        float right
                        width 0.64rem
                        height 0.53rem
                .zhibo
                    background:#FE4A3B;
                    .icon
                       background url('../../assets/tag_zhibo.svg')
                       background-size 100%
                       margin-top .12rem
                       margin-right .25rem
                .huifang
                    width 2.24rem
                    background #000000
                    .icon
                        height 0.48rem
                        background url('../../assets/tag_huifang.svg')
                        background-size 100%
                        margin-top 0.17rem
                        margin-right 0.14rem
                .item-title
                    position absolute
                    left 0
                    bottom 0
                    width 100%
                    height 2.29rem
                    box-sizing border-box
                    padding 0.59rem 0.43rem 0 0.43rem
                    font-size 0.53rem
                    font-weight 400
                    line-height 0.75rem
                    color #fff
                    background linear-gradient(180deg,rgba(29,29,29,0) 0%,rgba(29,29,29,0.7) 100%)
                    border-radius 0.21rem
                .info
                    margin-top 0.43rem
                    display flex
                    justify-content space-between
                    color #6A7082
                    font-size 0.64rem
                    line-height 1.07rem
                    p
                        display flex
                    .photo
                        width 1.07rem
                        height 1.07rem
                        margin-right 0.32rem
                        img 
                            width 100%
                            height 100%
                            border-radius 100%
</style>